import { useRecoilValue } from 'recoil'
import themes from '../../assets/styles/themes'
import Footer from '../../components/layout/Footer/Footer'
import GradeCard from '../../components/layout/GradeCard/GradeCard'
import {  Container } from '../../components/layout/Grid/Grid'
import Header from '../../components/layout/Header/Header'
import Title from '../../components/Typography/Title'
import UserState from '../../store/UserAtom'
import {
  CardsContent,
  FlexWrapper,
} from './styles'

function Classes({ history }: any) {
  const user = useRecoilValue(UserState)

  return (
    <>
      <Header />
      <CardsContent>
        <Container>
          <Title textcolor="#51A34F">Aulas</Title>
          <FlexWrapper>
            <GradeCard
              theme={themes.fundamental}
              title="Fundamental - Anos Iniciais"
              links={[
                {
                  externo: true,
                  label: '1º Ano',
                  link: '/conteudos/fundamental/18/?turma=1º Ano&title=Fundamental - Anos Iniciais',
                },
                {
                  externo: true,
                  label: '2º Ano',
                  link: '/conteudos/fundamental/19/?turma=2º Ano&title=Fundamental - Anos Iniciais',
                },
                {
                  externo: true,
                  label: '3º Ano',
                  link: '/conteudos/fundamental/20/?turma=3º Ano&title=Fundamental - Anos Iniciais',
                },
                {
                  externo: true,
                  label: '4º Ano',
                  link: '/conteudos/fundamental/21/?turma=4º Ano&title=Fundamental - Anos Iniciais',
                },
                {
                  externo: true,
                  label: '5º Ano',
                  link: '/conteudos/fundamental/22/?turma=5º Ano&title=Fundamental - Anos Iniciais',
                },
              ]}
            />
            <GradeCard
              theme={themes.fundamental_dois}
              title="Fundamental - Anos Finais"
              links={[
                {
                  externo: true,
                  label: '6º Ano',
                  link: '/conteudos/fundamental_dois/23/?turma=6º Ano&title=Fundamental - Anos Finais',
                },
                {
                  externo: true,
                  label: '7º Ano',
                  link: '/conteudos/fundamental_dois/24/?turma=7º Ano&title=Fundamental - Anos Finais',
                },
                {
                  externo: true,
                  label: '8º Ano',
                  link: '/conteudos/fundamental_dois/25/?turma=8º Ano&title=Fundamental - Anos Finais',
                },
                {
                  externo: true,
                  label: '9º Ano',
                  link: '/conteudos/fundamental_dois/26/?turma=9º Ano&title=Fundamental - Anos Finais',
                },
              ]}
            />
            <GradeCard
              theme={themes.ensino_medio}
              title="Ensino Médio - Seduc em Ação"
              links={[
                {
                  externo: true,
                  label: '1ª Série',
                  link: '/conteudos/ensino_medio/27/?turma=1ª Série&title=Ensino Médio - Seduc em Ação',
                },
                {
                  externo: true,
                  label: '2ª Série',
                  link: '/conteudos/ensino_medio/28/?turma=2ª Série&title=Ensino Médio - Seduc em Ação',
                },
                {
                  externo: true,
                  label: '3ª Série',
                  link: '/conteudos/ensino_medio/29/?turma=3ª Série&title=Ensino Médio - Seduc em Ação',
                },
              ]}
            />
            <GradeCard
              theme={themes.enem}
              title="Ensino Médio - ENEM"
              links={[
                {
                  externo: true,
                  label: 'Goiás bem no ENEM',
                  link: '/conteudos/enem/00/enem/?turma=Goiás Bem no ENEM - GOBEM&title=Ensino Médio - ENEM',
                },
              ]}
            />
            <GradeCard
              theme={themes.eja}
              title="EJA"
              links={[
                {
                  externo: true,
                  label: '1º semestre',
                  link: '/conteudos/eja/119/?turma=1º semestre&title=EJA',
                },
                {
                  externo: true,
                  label: '2º semestre',
                  link: '/conteudos/eja/120/?turma=2º semestre&title=EJA',
                },
                {
                  externo: true,
                  label: '3º semestre',
                  link: '/conteudos/eja/121/?turma=3º semestre&title=EJA',
                },
                {
                  externo: true,
                  label: '4º semestre',
                  link: '/conteudos/eja/122/?turma=4º semestre&title=EJA',
                },
              ]}
            />
            <GradeCard
              theme={themes.pratica_pedagogica}
              title="Subsídio à Prática Pedagógica"
              links={[
                {
                  externo: true,
                  label: 'Ensino Fundamental',
                  link: '/conteudos/pratica_pedagogica/252/?&title=Fundamental - Anos Finais&turma=Sub. à Prática Pedagógica',
                },
                {
                  externo: true,
                  label: 'Ensino Médio',
                  link: '/conteudos/pratica_pedagogica/251/?title=Ensino Médio&turma=Sub. à Prática Pedagógica',
                },
              ]}
            />
          </FlexWrapper>
        </Container>
      </CardsContent>
      <Footer />
    </>
  )
}

export default Classes
